import { render, staticRenderFns } from "./ChannelThumbnail.vue?vue&type=template&id=30d2e0c8&scoped=true"
import script from "./ChannelThumbnail.vue?vue&type=script&lang=js"
export * from "./ChannelThumbnail.vue?vue&type=script&lang=js"
import style0 from "./ChannelThumbnail.vue?vue&type=style&index=0&id=30d2e0c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30d2e0c8",
  null
  
)

export default component.exports